export function initDropZone() {
  const dropZone = getDropZone()
  if (dropZone) {
    dropZone.addEventListener('dragenter', handleDrag, false)
    dropZone.addEventListener('dragover', handleDrag, false)
    dropZone.addEventListener('dragleave', hideDropZone, false)
    window.addEventListener('dragenter', showDropZone, false)
  }
}

export function cleanupDropZone() {
  const dropZone = getDropZone()
  if (dropZone) {
    dropZone.removeEventListener('dragenter', handleDrag, false)
    dropZone.removeEventListener('dragover', handleDrag, false)
    dropZone.removeEventListener('dragleave', hideDropZone, false)
  }
  window.removeEventListener('dragenter', showDropZone, false)
}

function getDropZone() {
  return document.getElementById('dropzone')
}

function showDropZone(event) {
  if (event?.target?.closest('.drag-container')) return

  const dataTransfer = event.dataTransfer
  if (Object.values(dataTransfer.types).includes('Files')) {
    const dropZone = getDropZone()
    dropZone.style.display = 'block'
  }
}

export function hideDropZone() {
  const dropZone = getDropZone()
  dropZone.style.display = 'none'
}

function handleDrag(e) {
  e.dataTransfer.dropEffect = 'copy'
  e.preventDefault()
}
